const UNIDADES_FRACIONADAS = ['KG'];

export function resolverUnidadeProduto(produto) {
  if (!produto) {
    return '';
  }

  const unidade =
    produto.unidadeMedida ||
    produto.unidade ||
    produto.codigoUnidade ||
    produto.unidadeProduto ||
    '';

  return String(unidade)
    .trim()
    .toUpperCase();
}

export function produtoPermiteQuantidadeFracionada(produto) {
  return UNIDADES_FRACIONADAS.indexOf(resolverUnidadeProduto(produto)) >= 0;
}

export function quantidadeComoNumero(value, fallback = 0) {
  if (value === null || value === undefined || value === '') {
    return fallback;
  }

  const parsed = Number(String(value).replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function normalizarQuantidadeDigitada(value, produto) {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const parsed = quantidadeComoNumero(value, null);

  if (parsed === null) {
    return '';
  }

  if (produtoPermiteQuantidadeFracionada(produto)) {
    return parsed;
  }

  return Math.trunc(parsed);
}

export function getStepQuantidade(produto) {
  return produtoPermiteQuantidadeFracionada(produto) ? '0.001' : '1';
}
